import { Flag, Stars } from '@mui/icons-material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import UserIcon from '@mui/icons-material/Group';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router';
import { NonPermission } from '../components/NonPermission';
import { useAppContext } from '../contexts/AppContext';
import { hasRole } from '../utils/roles';
import { GoalsCreate } from './goals/GoalsCreate';
import { GoalsEdit } from './goals/GoalsEdit';
import { GoalsList } from './goals/GoalsList';
import { MembersCreate } from './members/MembersCreate';
import { MembersEdit } from './members/MembersEdit';
import { Profile } from './profile/Profile';
import { QualityIcon, QualityList } from './quality';
import { ReportList } from './reports/ReportList';
import { ReportSectionList } from './reportsSection/ReportSectionList';
import { ScoreList } from './score/ScoreList';
import { SettingIcon, SettingsList } from './settings';
import { TeamCreate } from './teams/TeamCreate';
import { TeamEdit } from './teams/TeamEdit';
import { TeamList } from './teams/TeamList';

// Hook para obtener recursos dinámicos usando el contexto
export const useDynamicResources = () => {
  const { currentApp } = useAppContext();

  const getDefaultResources = () => {
    if (currentApp === 'quality') {
      return [];
    }
    return ['score', 'goals', 'teams', 'members'];
  };

  const getSubMenuMetrics = () => {
    if (currentApp === 'quality') {
      return [];
    }
    return ['reports-teams', 'reports-sections'];
  };

  return {
    getDefaultResources,
    getSubMenuMetrics,
    currentApp,
  };
};

export const Resources = _permissions => {
  // Obtener la aplicación actual desde localStorage, por defecto 'card'
  const currentApp = localStorage.getItem('currentApp') || 'card';

  return (
    <>
      {/* Recursos de reportes - solo en Scuore Card */}
      {currentApp === 'card' && (
        <>
          <Resource
            name="reports-teams"
            list={ReportList}
            icon={AssignmentIndIcon}
            options={{ label: 'Por equipo' }}
          />

          <Resource
            name="reports-sections"
            list={ReportSectionList}
            icon={LeaderboardIcon}
            options={{ label: 'Por sección' }}
          />
        </>
      )}

      {/* Recursos comunes - solo en Scuore Card */}
      {currentApp === 'card' && (
        <>
          <Resource
            name="score"
            list={ScoreList}
            icon={Stars}
            options={{ label: 'Puntaje' }}
          />

          <Resource
            name="goals"
            create={hasRole(['admin', 'gerente']) ? GoalsCreate : NonPermission}
            list={hasRole(['admin', 'gerente', 'editor']) ? GoalsList : null}
            icon={Flag}
            options={{ label: 'Objetivos' }}
          />

          <Resource
            name="teams"
            create={hasRole(['admin', 'gerente']) ? TeamCreate : NonPermission}
            edit={hasRole(['admin', 'gerente']) ? TeamEdit : NonPermission}
            list={hasRole(['admin', 'gerente']) ? TeamList : null}
            icon={UserIcon}
            options={{ label: 'Equipos' }}
          />

          <Resource
            name="members"
            create={
              hasRole(['admin', 'gerente']) ? MembersCreate : NonPermission
            }
            edit={hasRole(['admin', 'gerente']) ? MembersEdit : NonPermission}
            list={null}
          />
        </>
      )}

      {/* Recurso Quality - en ambas aplicaciones */}
      <Resource
        name="quality"
        list={QualityList}
        icon={QualityIcon}
        options={{ label: 'resources.quality.singular_name' }}
      />

      <CustomRoutes>
        <Route
          path="goals/edit"
          element={
            hasRole(['admin', 'gerente']) ? <GoalsEdit /> : <NonPermission />
          }
        />
        <Route path="profile" element={<Profile />} />
      </CustomRoutes>

      {/* Settings - solo en Scuore Card */}
      {currentApp === 'card' && hasRole(['admin', 'gerente']) && (
        <Resource
          name="settings"
          list={SettingsList}
          icon={SettingIcon}
          options={{ label: 'resources.settings.singular_name' }}
        />
      )}
    </>
  );
};

// Función para obtener recursos según la aplicación actual
export const getDefaultResources = () => {
  const currentApp = localStorage.getItem('currentApp') || 'card';

  if (currentApp === 'quality') {
    return [];
  }

  return ['score', 'goals', 'teams', 'members'];
};

export const getSubMenuMetrics = () => {
  const currentApp = localStorage.getItem('currentApp') || 'card';

  if (currentApp === 'quality') {
    return [];
  }

  return ['reports-teams', 'reports-sections'];
};

export const defaultResources = [
  'score',
  'goals',
  'teams',
  'members',
  'quality',
];
export const subMenuMetrics = ['reports-teams', 'reports-sections'];
export const submenues = ['reports'];

export default Resources;
